export const READ_ALOUD_VOICES = [
  'alloy',
  'ash',
  'ballad',
  'cedar',
  'coral',
  'echo',
  'fable',
  'marin',
  'nova',
  'onyx',
  'sage',
  'shimmer',
  'verse',
] as const

export type ReadAloudVoice = typeof READ_ALOUD_VOICES[number]

export const DEFAULT_READ_ALOUD_VOICE: ReadAloudVoice = 'marin'
export const DEFAULT_READ_ALOUD_SPEED = 2
export const READ_ALOUD_MIN_SPEED = 0.25
export const READ_ALOUD_MAX_SPEED = 4
export const READ_ALOUD_SPEED_STEP = 0.25

const READ_ALOUD_VOICE_SET = new Set<string>(READ_ALOUD_VOICES)

const VOICE_LABELS: Record<ReadAloudVoice, string> = {
  alloy: 'Alloy',
  ash: 'Ash',
  ballad: 'Ballad',
  cedar: 'Cedar',
  coral: 'Coral',
  echo: 'Echo',
  fable: 'Fable',
  marin: 'Marin',
  nova: 'Nova',
  onyx: 'Onyx',
  sage: 'Sage',
  shimmer: 'Shimmer',
  verse: 'Verse',
}

export function isReadAloudVoice(value: unknown): value is ReadAloudVoice {
  return typeof value === 'string' && READ_ALOUD_VOICE_SET.has(value)
}

export function normalizeReadAloudVoice(value: unknown): ReadAloudVoice {
  return isReadAloudVoice(value) ? value : DEFAULT_READ_ALOUD_VOICE
}

export function normalizeReadAloudSpeed(value: unknown): number {
  const parsed = typeof value === 'number' || typeof value === 'string'
    ? Number(value)
    : Number.NaN
  if (!Number.isFinite(parsed)) return DEFAULT_READ_ALOUD_SPEED
  const clipped = Math.min(READ_ALOUD_MAX_SPEED, Math.max(READ_ALOUD_MIN_SPEED, parsed))
  const stepped = Math.round(clipped / READ_ALOUD_SPEED_STEP) * READ_ALOUD_SPEED_STEP
  return Number(stepped.toFixed(2))
}

export function readAloudSpeedLabel(speed: number): string {
  return `${normalizeReadAloudSpeed(speed).toFixed(2).replace(/\.00$/, '').replace(/0$/, '')}x`
}

export function readAloudVoiceLabel(voice: ReadAloudVoice): string {
  return VOICE_LABELS[voice]
}
